SocialReview = {
    send: function (categoryID) {
        var IDPrintMessage = '#sSocialReviewMessage';

        S.printMessage(IDPrintMessage, 'hide');

        var name = S.val('#iSocialReviewName');
        var rating = S.val('#selSocialReviewRating');
        var text = S.val('#iSocialReviewText');

        var btn = S.createAnimationButton('#bSocialReviewSend');

        S.startAnimationButton(btn);

        S.ajax('social/review/send', {
            category_id: categoryID,
            name: name,
            rating: rating,
            text: text
        }, function (data) {
            try {
                if (data.error) {
                    switch (data.error.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'error', S.messagesJoin(data.error.data.messages));
                            break;
                        }

                        default: {
                            S.unknownErrorCode(data);
                        }
                    }
                } else if (data.success) {
                    switch (data.success.code) {
                        case 1: {
                            S.printMessage(IDPrintMessage, 'success', S.messagesJoin(data.success.data.messages));
                            $('#iSocialReviewName').val('');
                            $('#selSocialReviewRating').val('5');
                            $('#iSocialReviewText').val('');
                            break;
                        }

                        default: {
                            S.unknownSuccessCode(data);
                        }
                    }
                }
            } catch (e) {
                S.log(e);
            }
        }, function () {
            S.stopAnimationButton(btn);
        });
    }
};
